import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextMonoSignal = () => {

return(
<div>
    
<Typography variant="h6" >

Genetic insights from gene discovery efforts are increasingly being used in the context of precision medicine in ways that directly affect health. 
 Knowing a patient’s genotype may enable a more precise diagnosis of the type of obesity, which in turn allows the prescription of personalized treatment or prevention strategies. 
 Furthermore, knowing an individual’s genetic susceptibility to obesity early in life may help to more accurately predict those most at risk of gaining weight in the future.
 <br /><br /> 
 Ultimate Goal: the ability to move away from a failed ‘one-size-fits-all’ strategy, and towards true precision medicine for obesity, metabolic disease and other diet-related illnesses.
                            <br /><br /> 
                           We analyzed over 3000 genes which are associated with obesity / BMI and selected the ones which are marked in clinvar either as pathogenic, likely pathogenic,  as risk factor or as drugtype relevant.
                           <br /><br /> 
                           6 genetic variants were found which should be discussed regarding obesity in genetic counceling.

 
</Typography>

</div>
)
}